import classNames from "classnames";

import style from "./UserName.module.css"; // eslint-disable-line

interface UserNameProps {
  name: string;
  isCurrentUser?: boolean;
  color?: "gray";
}

export const UserName = ({ name, isCurrentUser, color }: UserNameProps) => {
  const initial = [...name.replace(/[()]/g, "")][0];
  return (
    <div className={style.wrapper}>
      <div className={classNames([style.avatar, color ? style[color] : ""])}>{initial}</div>
      <span className={style.name} title={name}>
        {name}
      </span>
      {isCurrentUser && <span className={style.youBadge}>(You)</span>}
    </div>
  );
};
